import React, { useState, useMemo, useCallback } from 'react';
import './TopNav.scss';
import logoIconSvg from '../Dashboard/logo-icon-light.svg';
import logoTextSvg from '../Dashboard/logo-text-light.svg';
import { Menu, X } from 'react-feather';
import PropTypes from 'prop-types';
import { classNames } from '../../utils';
import Tabs from './Tabs';
import TabOverview from './Tabs/TabOverview';
import AccountMenu from './AccountMenu';
import { IconButton, Link } from 'ui-kit';
import NewStore from 'components/Dashboard/Store/StoreModal/Actions/NewStore';
import { useHistory, useParams } from 'react-router-dom';
import { useSignedUser, newLogout } from 'api/auth';
import { useStoreDetails } from 'api/store';
import { reverse } from 'utils/urls';
import { URLS } from 'components/Routes/urls';

const TopNav = ({ className }) => {
  const params = useParams();
  const storeId = useMemo(() => (params.storeId ? Number(params.storeId) : null), [params.storeId]);
  const { data: store } = useStoreDetails(storeId, storeId !== null);

  const history = useHistory();

  const { data: user } = useSignedUser();
  const isMasquerading = useMemo(() => user?.is_masqueraded, [user]);

  const [isNewStoreModalOpen, setIsNewStoreModalOpen] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = useCallback(() => newLogout().then(() => (window.location.href = '/')), []);

  const handleNewStoreModalOpen = () => {
    setIsNewStoreModalOpen(true);
  };

  const handleNewStoreModalClose = () => {
    setIsNewStoreModalOpen(false);
  };

  const handleToogleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const isCoHost = useMemo(() => user?.is_cohost, [user]);

  return (
    <div className={classNames(className, 'TopNav', isMasquerading && 'masquerading')}>
      <Link to="/overview/stores/" className="TopNav_brand">
        <img className="TopNav_logoAsIcon" src={logoIconSvg} alt="Logo As Icon" />
        <img className="TopNav_logoAsText" src={logoTextSvg} alt="Logo As Text" />
      </Link>
      <div className="TopNav_content">
        <div className="TopNav_content-primary">
          <IconButton
            className="TopNav_content-burgerMenuButton"
            color="textLight"
            onClick={handleToogleDrawer}
          >
            <Menu className="menuIcon" />
          </IconButton>
          <TabOverview mode="horizontal" onAddStore={handleNewStoreModalOpen} />
        </div>
        <img className="TopNav_logoAsIcon" src={logoIconSvg} alt="Logo As Icon" />
        <div className="TopNav_content-secondary">
          <AccountMenu onSignOut={handleLogout} isCoHost={isCoHost} />
        </div>
      </div>
      <div className={classNames('TopNav_drawer', isDrawerOpen ? 'show' : '')}>
        <div className="TopNav_drawer_backdrop" onClick={() => setDrawerOpen((prev) => !prev)} />
        <div className="TopNav_drawer_container">
          <div className="TopNav_drawer_container-topBar">
            <IconButton
              className="TopNav_drawer_container-closeButton"
              color="textLight"
              fullWidth
              onClick={handleToogleDrawer}
            >
              <X />
            </IconButton>
          </div>
          <Tabs
            store={store}
            reset={!isDrawerOpen}
            onAddStore={handleNewStoreModalOpen}
            onLogout={handleLogout}
            mode="inline"
          />
        </div>
      </div>
      <NewStore
        isOpen={isNewStoreModalOpen}
        onCancel={handleNewStoreModalClose}
        onSuccess={(store) =>
          history.push(
            reverse({
              url: URLS.STORE_DETAILS,
              params: { storeId: store.id },
            }),
          )
        }
      />
    </div>
  );
};

TopNav.propTypes = {
  className: PropTypes.string,
};

export default TopNav;
